(ns app.front.view.archiving.view
  (:require [app.domain.archiving.model :as archiving-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.util :refer [for-frag]]
            [app.front.view.application.page-content :as app-page]
            [app.front.view.archiving.components :as arch-comp]
            [app.front.view.workspace.phase-errors :as phase-errors]
            [app.front.view.workspace.section :as ws-section]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx
  ::fetch-current-configuration
  (fn [_ [_ archiving]]
    {:dispatch-n [[:app.front.process/signal
                   (:db/id archiving)
                   [:process.signal/fetch-current-archiving-config]
                   {:notify {:success :archiving/configuration-fetched}}]]}))


(rf/reg-event-fx
  ::update-archiving-field
  (fn [_ [_ archiving field-id value]]
    {:dispatch [:app.front.process/signal
                (:db/id archiving)
                [:process.signal/update-archiving-field
                 {:field-id field-id
                  :value    value}]]}))


(rf/reg-sub ::archiving-fields
  (fn [[_ archiving-id]]
    (rf/subscribe [::entities/entities {:entity/type   :entity.type/archiving-field
                                        :entity/parent archiving-id}]))
  :-> archiving-model/filter-archiving-fields)


(defn archiving-view
  "The archiving page on the workspace in its entirety"
  [{:keys [archiving tr workspace loading?]}]
  (let [domain-state       (:domain/state archiving)
        archiving-fields   (<sub [::archiving-fields (:db/id archiving)])
        archiving-metadata (->> (<sub [::entities/entities {:entity/type   :entity.type/archiving-metadata
                                                            :entity/parent (:db/id archiving)}])
                                (sort-by :db/id))
        loading?           (or (nil? archiving) loading?)]
    [app-page/page-content
     (util/mmap {:process-target archiving
                 :process        (<sub [::process/archiving-process])}
                workspace
                tr
                loading?)
     [:<>
      [phase-errors/errors tr [::process/archiving-process]]
      [ws-section/section
       archiving
       :application-inspections
       (util/mmap tr loading?)
       :archiving/archiving-metadata
       false
       (when (= domain-state :archiving.state/set-metadata)
         [:<>
          [:div.flex.flex-row.flex-wrap
           (for-frag [{:archiving-field/keys [schema value selected-value] id :db/id} archiving-fields]
             (let [on-change (fn [value]
                               (>evt [::update-archiving-field archiving id value]))
                   id        (str "archiving-field-" (or id (:db/id schema)))
                   label     (:archiving-field-schema/field-name schema)
                   required  true
                   disabled  (not (<sub [:app.front.process/archiving-signal-permitted?
                                         [:process.signal/update-archiving-field
                                          {:field-id id
                                           :value    value}]]))]
               (arch-comp/archiving-field-input
                 schema
                 (util/mmap tr value selected-value required on-change id label disabled))))]
          (when (<sub [:app.front.process/archiving-signal-permitted?
                       [:process.signal/fetch-current-archiving-config]])
            (cc/button {:kind             :tertiary
                        :class-name       "mt-6"
                        :icon-position    :right
                        :icon-description (tr [:archiving/fetch-current-configuration])
                        :on-click         #(>evt [::fetch-current-configuration archiving])}
                       (tr [:archiving/fetch-current-configuration])))])
       [:div.flex
        (for-frag [{:keys [:archiving-metadata/attr :archiving-field/value]} archiving-metadata]
          [:div.mr-8
           [:span.bold (tr [attr])]
           [:p.mt-2
            (cond
              (keyword? value) (tr [value])
              (inst? value) ((<sub [::date-util/date-fn]) value)
              :else value)]])]]]]))
